<template>
  <article class="salemanage-entrance">
    <group :gutter="mt20" v-if="showManage">
      <cell link="/salemanage/manage/mywork" class="salemanage-entrance-cell">
        <img slot="icon" class="sale-img" src="../../stylesheets/images/icon-manage.png" />
        <span slot="after-title">我是经理</span>
      </cell>
    </group>
    <group :gutter="mt20" v-if="showStaff">
      <cell link="/salemanage/staff/mywork" class="salemanage-entrance-cell">
        <img slot="icon" class="sale-img" src="../../stylesheets/images/icon-staff.png" />
        <div slot="after-title">我是员工</div>
      </cell>
    </group>
  </article>
</template>

<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../common/auth'

export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      // 经理权限(具有客户管理与签单审核权限+查看全部客户权限)
      manage: [authApi.saleManage.sale_potential_customer_manage, authApi.saleManage.sale_potential_customer_view_all],
      // 员工权限(以下任意一种)
      // 1.跟进客户权限 + 查看个人客户权限)
      staff1: [authApi.saleManage.sale_potential_customer_follow_up, authApi.saleManage.sale_potential_customer_view_self],
      // 2.跟进个人线索权限 + 查看个人线索权限
      staff2: [authApi.saleManage.sale_clue_follow_self, authApi.saleManage.sale_clue_view_self],
      // 3.跟进全部线索权限 + 查看全部线索
      staff3: [authApi.saleManage.sale_clue_follow_all, authApi.saleManage.sale_clue_view_all],
      showManage: false,
      showStaff: false,
      mt20: '0.53333333rem'
    }
  },
  created () {
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      // 满足经理权限要求
      this.showManage = authApi.haveEveryAuth(this.manage, authList)
      let firstPer = authApi.haveEveryAuth(this.staff1, authList)
      let secondPer = authApi.haveEveryAuth(this.staff2, authList)
      let thirdPer = authApi.haveEveryAuth(this.staff3, authList)
      // 满足员工权限要求
      this.showStaff = firstPer || secondPer || thirdPer
      if (this.showManage) {
        if (!this.showStaff) {
          this.$router.push('/salemanage/manage/mywork')
        }
      } else if (this.showStaff) {
        this.$router.push('/salemanage/staff/mywork')
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {}
}
</script>
<style lang="less">
@w2: 75rem;
.salemanage-entrance {
  padding: 0 30/@w2;
  box-sizing: border-box;
  overflow: hidden;
  .salemanage-entrance-cell {
    padding: 50/@w2 30/@w2;
    .sale-img {
      display: block;
      width: 100/@w2;
      height: 100/@w2;
      margin-right: 30/@w2;
      border-radius: 50%;
    }
  }
}
</style>
